import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { array, func, string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import CardDropdownList from './CardDropDownList';

const PrescriptionDiscountSearch = ({
  searchPharmacies,
  pharmacyName,
  setSelectedPharmacy
}) => {
  const [suggestionList, setSuggestionList] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [cardPharmacy, setcardPharmacy] = useState(searchPharmacies);
  const [submitId, setSubmitId] = useState(0);
  const { t } = useTranslation();
  const searchInput = useRef();

  useEffect(() => {
    setInputValue(pharmacyName);
  }, [pharmacyName]);

  const handleInputFocus = event => {
    event.preventDefault();
    const { value } = event.target;
    if (_.isEmpty(value)) {
      setcardPharmacy(searchPharmacies);
    } else {
      const searchRegex = value.trim().toLowerCase();
      const searchResult = _.filter(searchPharmacies, item =>
        item.name.toLowerCase().includes(searchRegex)
      );
      setcardPharmacy(searchResult);
    }
    setSuggestionList(true);
  };

  const handleInputChange = event => {
    event.preventDefault();
    const searchRegex = event.target.value.trim().toLowerCase();
    const searchResult = _.filter(searchPharmacies, item =>
      item.name.toLowerCase().includes(searchRegex)
    );
    setInputValue(event.target.value);
    setcardPharmacy(searchResult);
  };

  const handleOnBlur = event => {
    event.preventDefault();
    setSuggestionList(false);
    setcardPharmacy(searchPharmacies);
    setSubmitId(_.isEmpty(event.target.value) ? 0 : submitId);
  };

  const handleSubmit = pharmacy => {
    const { offsetWidth } = searchInput && searchInput.current;
    setSuggestionList(false);
    setSelectedPharmacy(pharmacy, offsetWidth >= 330 ? false : true);
  };

  const setId = id => {
    setSubmitId(id);
  };

  const clearSearchValue = event => {
    event.stopPropagation();
    event.preventDefault();
    setSuggestionList(true);
    setInputValue('');
    searchInput.current.focus();
    setcardPharmacy(searchPharmacies);
  };

  return (
    <div>
      <section className="search-masthead">
        <div
          id="vm-search"
          className="site-search open"
          role="search"
          aria-label="Type your drug name"
        >
          <div className="site-search-form search-center">
            <form className={'search-form-wd'} autoComplete="off">
              <div className="site-search-form--query">
                <span className="searchIcon"></span>
                <input
                  type="search"
                  className="sc-form__text site-search-form--term themeFocus"
                  id="searchbar"
                  ref={searchInput}
                  placeholder={t('Search pharmacies')}
                  autoComplete="off"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  onBlur={handleOnBlur}
                  value={inputValue}
                  tabIndex="0"
                  aria-labelledby="search-your-pharmacy"
                  aria-required="true"
                  aria-controls="get-discount-card"
                  aria-activedescendant={`option ${submitId}`}
                />
                {!_.isEmpty(inputValue.trim()) && (
                  <button
                    className="crossbutton"
                    onClick={clearSearchValue}
                    aria-label={t('Clear search text')}
                  >
                    <img
                      src="/content/images/icons/search-close-x-icon.svg"
                      alt={t('Remove search')}
                    />
                  </button>
                )}
              </div>
            </form>
          </div>
          {suggestionList && (
            <CardDropdownList
              cardPharmacy={cardPharmacy}
              handleSubmit={handleSubmit}
              submitId={submitId}
              setId={setId}
            />
          )}
        </div>
      </section>
    </div>
  );
};

PrescriptionDiscountSearch.propTypes = {
  searchPharmacies: array,
  setSelectedPharmacy: func,
  pharmacyName: string
};

PrescriptionDiscountSearch.defaultProps = {
  searchPharmacies: [],
  setSelectedPharmacy: () => {},
  pharmacyName: ''
};

export default PrescriptionDiscountSearch;
